// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'flex.css/dist/data-flex.css';
import Vue from 'vue'
import {
  Toast
} from 'mint-ui'
import {
  time
} from './common/utils/time'
import {
  getUrlParam
} from './common/utils/url'
import preview from 'vue-photo-preview';
import 'vue-photo-preview/dist/skin.css';
// import AlloyLever from 'alloylever'
import App from './App'
import router from './router'
import store from './store'
import storage from 'storejs'
import moment from 'moment'; //时间格式转化

Vue.prototype.$moment = moment;

import * as plantform from '@/common/utils/plantform';
import commonService from '@/common/service/commonService'

import Vconsole from 'vconsole'
import {
  getUid
} from '@/common/utils/getUserInfo';

import serviceAPI from '@/common/service/serviceAPI';

// const vConsole = new Vconsole()
// Vue.use(vConsole)

Vue.config.productionTip = true
Vue.prototype.$toast = Toast
Vue.use(preview);

dsBridge.call('base.register', '[1,2,3,4,5,6,7]')

router.beforeEach(async (to, from, next) => {

  const nxt = storage.get('nxt') || {};

  if (to.path !== '/login' && to.path !== '/agree' && to.path !== '/setting') {
    storage.set({
      'from': {
        path: to.path,
        query: to.query
      }
    })
  }

  console.log('环境', plantform.isWechat)
  // 如果query中存在tempJSInteractionFlag的场合，为医生站app免登录
  if (location.href.indexOf('tempJSInteractionFlag') >= 0 && !plantform.isWechat && to.path !== '/login' && to.path !== '/agree') {
    try {
      let uid = await getUid();
      // let uid = 7513;
      console.log(uid, '我是uid');
      // 获取医生站uid
      const yszUid = nxt.yszUid || '';
      if (uid <= 0 && !nxt.encrypt) {

        let _nxt = {
          yszUid: uid
        };
        storage({
          nxt: _nxt
        });
        next({
          path: '/agree'
        })
        return;
      }

      if (uid && uid > 0) {
        if (!nxt.encrypt || yszUid.toString() !== uid.toString()) {
          const res = await serviceAPI.loginYSZ({
            yxjUserId: uid,
            regSource: 6,
            platform: 'APP',
            openId: new Date().getTime(),
          });

          console.log(res, '返回数据');
          let _nxt = storage.get('nxt') || {}
          _nxt = Object.assign(_nxt, {
            encrypt: res.encrypt,
            userId: res.data.userId,
            yszUid: uid
          });
          storage({
            nxt: _nxt
          })
          console.log(storage.get('nxt'), 'storage,nxt');
          next();
          return;
        }
      }
    } catch (error) {

      if (!nxt.encrypt) {
        console.log('app登录错误');
        next({
          path: '/agree'
        })
      }
      next();
      return;
    }

  } else if (!nxt.encrypt) {
    console.log(to, '怎么可以吃兔兔')

    if (!nxt.agree && to.path !== '/agree' && to.path !== '/videoDetail' && to.path !== '/articleDetail' && to.path !== '/pptDetail') {
      next({
        path: '/agree'
      })
      console.log('跳转知情同意书');
      return;
    }
    if (nxt.agree && !nxt.encrypt && to.path !== '/login' && to.path !== '/videoDetail' && to.path !== '/articleDetail' && to.path !== '/pptDetail') {
      next({
        path: '/login'
      })
      console.log('跳转登录页');
      return;
    }
  }





  const encrypt = nxt.encrypt || getUrlParam('shareEncrypt') || ''
  const isVisitor = !!getUrlParam('shareEncrypt') && !getUrlParam('appencrypt') && !nxt.encrypt;

  const userId = nxt.userId || getUrlParam('userId') || ''
  store.state.encrypt = encrypt
  store.state.userId = userId
  store.state.isVisitor = isVisitor

  console.log('继续执行', to.matched.some(record => record.meta.open));
  // if (to.matched.some(record => record.meta.open)) {
  //     next()
  // } else {
  //     if (encrypt) {
  //         if (nxt.agreen) {
  //             next()
  //         } else {
  //             next({
  //                 path: '/agree'
  //             })
  //         }
  //     } else {
  //         const from = encodeURIComponent(to.fullPath)
  //         if (!nxt.agreen) {
  //             next({
  //                 path: '/agree'
  //             })
  //         } else {
  //             next()
  //         }
  //     }
  // }
  next();
})

router.onReady(() => {
  // if (plantform.isWechat && store.state.encrypt) {
  //   commonService.getJsTiket(store.state.encrypt)
  //     .then(res => {
  //       const signParams = Object.assign({}, res.rsps[0].body, {
  //         debug: false,
  //         jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline', 'hideOptionMenu'],
  //       })
  //       wx.config(signParams)
  //       wx.ready(function () {
  //         var params = {
  //           title: '专心医致',
  //           desc: '专心一致，医治心衰',
  //           link: `${location.href}`,
  //           imgUrl: 'http://studioppt.yxj.org.cn/20180420172342.png',
  //         };
  //         wx.onMenuShareAppMessage(params);
  //         wx.onMenuShareTimeline(params);
  //       });
  //     })
  // } else {}
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js